import LanguageToggle from '../../src/legacy/LanguageToggle.tsx';
export default LanguageToggle;
